import { atom } from 'recoil';
import { HikariTv } from '@/types/api/mypage/options';
import persistAtom from './recoilPersist';

/**
 * ひかりTVオプションの契約情報を保持する state。
 * 契約状況や申込可否をセッション中に維持し、複数画面から同じ情報を参照できるようにする。
 */
export const HikariTvOptionInfoState = atom<HikariTv>({
  key: 'HikariTvOptionInfoState',
  default: {
    is_using: false,
    can_entry: false,
    contract_info: [],
  },
  effects_UNSTABLE: [persistAtom],
});

export default HikariTvOptionInfoState;
